import { type FC, useState } from "react";

import { TERM_ID_QUERY_PARAM } from "components/constants";
import { t } from "i18n/i18n";
import { TextField } from "mds/components/TextField";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { storeApi } from "store/index";
import { toastSuccessMessage } from "utils/alerts";
import { useQueryParamsActions } from "utils/routing";

type AddTermModalProps = {
  eventName?: string;
  eventProperties?: Record<string, unknown>;
  localTerms: Array<{ order?: number }>;
  onClose: () => void;
};

export const AddTermModal: FC<AddTermModalProps> = ({
  eventName,
  eventProperties,
  localTerms,
  onClose,
}) => {
  const [name, setName] = useState("");
  const { setQueryParams } = useQueryParamsActions();

  const handleSubmit = () => {
    if (!name.trim()) {
      return;
    }

    const newOrder = (localTerms[localTerms.length - 1]?.order || 0) + 1;
    storeApi.terms
      .create({
        order: newOrder,
        title: name.trim(),
      })
      .then((newItem) => {
        toastSuccessMessage(t("home.toasts.term_added"));
        setQueryParams({ [TERM_ID_QUERY_PARAM]: newItem.id });
        onClose();
      });
  };

  return (
    <div>
      <label className="flex flex-col gap-1">
        <div>{t("nav_list.new_title_term")}</div>
        <TextField
          eventName={eventName}
          eventProperties={eventProperties}
          placeholder={t("home.placeholder.term_name")}
          value={name}
          isEditing
          onChange={(e) => setName(String(e.target.value))}
          onKeyDown={(e) => {
            if (e.key === "Enter" && name.trim()) {
              handleSubmit();
            }
          }}
        />
      </label>

      <div className="mt-8 flex w-full justify-end gap-2">
        <SquareButton kind="tertiary" size="m" title={t("common.cancel")} onClick={onClose}>
          {t("common.cancel")}
        </SquareButton>

        <SquareButton
          disabled={!name.trim()}
          kind="accent"
          size="m"
          title={t("common.add.term")}
          onClick={handleSubmit}
        >
          {t("common.add.term")}
        </SquareButton>
      </div>
    </div>
  );
};
